import {
  CuePoint
} from '../../store/presenter-slide-management-store/presentation-config-aggregate/presentation-config-aggregate-types/presentation-config-aggregate-types';

export enum LiveCommands {
  CUEPOINT = 'CUEPOINT',
  DISCONNECT = 'DISCONNECT',
  RECONNECT = 'RECONNECT'
}

export interface ICommandObject {
  type: LiveCommands;
  stream_time: number;
  backup_stream_time: number;
  backup_stream: boolean;
  content: string;
  livePresentationId: number;
}

export interface ICuePointCommandObject extends ICommandObject {
  type: LiveCommands.CUEPOINT;
}

export interface IDisconnectAttendeeCommandObject extends ICommandObject {
  type: LiveCommands.DISCONNECT;
}

export interface IDisconnectAttendeeContent {
  uniqueViewerId: string;
}

export type TContent = CuePoint | IDisconnectAttendeeContent;

const createCommandObject = (type: LiveCommands, content: TContent, livePresentationId: number): ICommandObject => {
  return {
    type,
    stream_time: 0,
    backup_stream_time: 0,
    backup_stream: false,
    content: JSON.stringify(content),
    livePresentationId: livePresentationId
  };
};

const createCuePointCommandObject = (cuePoint: CuePoint, livePresentationId: number): ICuePointCommandObject => {
  return createCommandObject(LiveCommands.CUEPOINT, cuePoint, livePresentationId) as ICuePointCommandObject;
};

const createChangeConnectionStatusAttendeeCommandObject = (
  content: IDisconnectAttendeeContent,
  livePresentationId: number,
  liveCommand: LiveCommands
): IDisconnectAttendeeCommandObject => {
  return createCommandObject(liveCommand, content, livePresentationId) as IDisconnectAttendeeCommandObject;
};

export {
  createCuePointCommandObject,
  createChangeConnectionStatusAttendeeCommandObject
};
